import { useContext } from 'react'

import { ModelDataSecurityContext } from './context'

export function useModelDataSecurity() {
  const context = useContext(ModelDataSecurityContext)
  if (!context) throw new Error('useModelDataSecurity must be used within ModelDataSecurityProvider')
  return context
}
